import React, { Component } from 'react'

import { Tabs } from 'antd'

import ColumnTitle from '../ColumnTitle'

import rctit from '../../assets/img/rctit.png'

import { MeetingAgendaWrapper, TextWrapper } from './style'

const { TabPane } = Tabs;

export default class MeetingAgenda extends Component {



    render() {
        return (
            <MeetingAgendaWrapper>
                <ColumnTitle imgSrc={rctit} />
                <Tabs defaultActiveKey="1" className="tabs">
                    <TabPane tab="议题一" key="1">
                        <TextWrapper>
                            <h3>后疫情时代的全球与中国经济</h3>
                            <p className="mtb"><b>主持人：</b></p>
                            <p><span></span>钱  彤：新华网总编辑</p>
                            <p className="mtb"><b>主题演讲：</b></p>
                            <p><span></span>刘世锦：全国政协经济委员会副主任</p>
                            <p><span></span>高培勇：中国社科院副院长</p>
                            <p><span></span>刘元春：中国人民大学副校长</p>
                            <p><span></span>刘尚希：中国财政科学研究院院长</p>
                            <p><span></span>张  军：复旦大学经济学院院长</p>
                            <p><span></span>郑永年：香港中文大学(深圳)全球与当代中国高等研究院院长</p>
                        </TextWrapper>
                    </TabPane>
                    <TabPane tab="议题二" key="2">
                        <TextWrapper>
                            <h3>新一轮产业变革下的挑战与机遇</h3>
                            <p className="mtb"><b>主持人：</b></p>
                            <p><span></span>张小琴：清华大学新闻与传播学院教授</p>
                            <p className="mtb"><b>主题演讲：</b></p>
                            <p><span></span>贺克斌：中国工程院院士、清华大学碳中和研究院院长</p>
                            <p><span></span>白重恩：清华大学经济管理学院院长</p>
                            <p><span></span>朱云来：金融专业人士</p>
                            <p><span></span>黄群慧：中国社科院经济研究所所长</p>
                            <p><span></span>许宪春：国家统计局原副局长、清华大学经济管理学院教授</p>
                        </TextWrapper>
                    </TabPane>
                    <TabPane tab="议题三" key="3">
                        <TextWrapper>
                            <h3>科技创新与产业革命</h3>
                            <p className="mtb"><b>主持人：</b></p>
                            <p><span></span>华智云：新华智云元宇宙新闻主播</p>
                            <p className="mtb"><b>主题演讲：</b></p>
                            <p><span></span>薛  澜：清华大学人工智能国际治理研究院院长</p>
                            <p><span></span>吕廷杰：中国信息经济学会副理事长</p>
                            <p><span></span>陈少峰：北京大学文化产业研究院副院长</p>
                            <p><span></span>赵国栋：中关村大数据产业联盟秘书长</p>
                            <p><span></span>徐常亮：新华智云科技有限公司总裁</p>
                        </TextWrapper>
                    </TabPane>
                    <TabPane tab="议题四" key="4">
                        <TextWrapper>
                            <h3>常态化防控与公共卫生体系建设</h3>
                            <p className="mtb"><b>主持人：</b></p>
                            <p><span></span>刘   娟：新华网副总编辑</p>
                            <p className="mtb"><b>主题演讲：</b></p>
                            <p><span></span>仝小林：中国科学院院士、中医内科学家</p>
                            <p><span></span>曾   光：中国疾病预防控制中心流行病学前首席科学家</p>
                            <p><span></span>张克镇：北京泰济堂中医院院长</p>
                            <p><span></span>刘国恩：北京大学全球健康发展研究院院长</p>
                        </TextWrapper>
                    </TabPane>
                </Tabs>
            </MeetingAgendaWrapper>
        )
    }
}
